
import { pipelineContext, runPipeline } from './pipelineRunner.js'
import { canDeclineClaimPipeline } from './canDeclineClaimPipeline.js'

let runCanDeclineClaimPipeline = (selectedClaim) => {

    let context = pipelineContext(selectedClaim)


    return runPipeline(canDeclineClaimPipeline, context)
}

export { runCanDeclineClaimPipeline }